<template>
  <div class="stepsdemo-content">
    <Card>
      <template #title> Responsável do Evento </template>
      <template #subtitle> Informe o responsável do evento. </template>
      <template #content>
        <div class="p-fluid grid">
          <div class="col-12">
            <div class="field">
              <label for="responsible">Responsável</label>
              <AutoComplete
                v-model="responsibleSelected"
                placeholder="Selecione o responsável pelo evento"
                optionLabel="name"
                dropdown
                :suggestions="responsibles"
                @complete="getResponsibles"
              >
                <template #option="slotProps">
                  <div class="flex align-options-center">
                    <div>
                      <b>Nome: </b>{{ slotProps.option.name }}<br /><b
                        >Email: </b
                      >{{ slotProps.option.email }}
                    </div>
                  </div>
                </template>
              </AutoComplete>
            </div>
            <div class="field">
              <span
                class="title-badge hvr-grow"
                @click="showCreateResponsible()"
              >
                NÃO ENCONTROU O RESPONSÁVEL, CLIQUE AQUI!
              </span>
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <div class="grid grid-nogutter justify-content-between">
          <Button
            label="Voltar"
            @click="prevPage()"
            icon="pi pi-angle-left"
            iconPos="left"
          />
          <Button
            label="Próximo"
            @click="nextPage(v$.$invalid)"
            icon="pi pi-angle-right"
            iconPos="right"
          />
        </div>
      </template>
    </Card>
    <dialog-form :objSelected="responsible" @findAll="getResponsibles" />
  </div>
</template>

<script>
// VALIDATIONS
import { useVuelidate } from "@vuelidate/core";
import { required } from "vuelidate/lib/validators";

// SERVICE
import ResponsibleService from "../../../service/internal/responsible/responsible_service";
import Event from "../../../models/internal/event";
import Responsible from "../../../models/internal/responsible";

// COMPONENTS
import DialogForm from "../../responsible/components/dialog-form.vue";

export default {
  props: ["formObject"],
  components: {
    DialogForm,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      submitted: false,
      pageIndex: 0,
      service: new ResponsibleService(),
      responsibles: [],
      responsibleSelected: null,
      lazyParams: null,
      formData: new Event(),
      responsible: new Responsible({}),
    };
  },
  validations() {
    return {
      responsibleSelected: {
        required,
      },
    };
  },
  created() {
    if (this.formObject.responsible.id !== null) {
      this.responsibleSelected = this.formObject.responsible;
    }
  },
  mounted() {
    this.lazyParams = {
      name: "",
    };
  },
  methods: {
    getResponsibles() {
      this.lazyParams.name =
        this.responsibleSelected == null ? "" : this.responsibleSelected;
      this.service.findAllResponsible(this.lazyParams).then((data) => {
        this.responsibles = data.content;
      });
    },
    nextPage(isFormValid) {
      this.submitted = true;

      if (!isFormValid || !this.isObject(this.responsibleSelected)) {
        this.$msgInfo("Para prosseguir é necessário selecionar um responsável para o evento.")
        return;
      }

      this.formData = new Event();
      this.responsibleSelected = new Responsible(this.responsibleSelected);
      this.formData.responsible = this.responsibleSelected;

      this.$emit("nextPage", {
        formData: this.formData,
        pageIndex: this.pageIndex,
      });
    },
    prevPage() {
      this.$emit("prevPage", {
        formData: {
          responsible: this.responsibleSelected,
        },
        pageIndex: this.pageIndex - 1,
      });
    },
    showCreateResponsible() {
      this.$store.state.views.responsible.dialogForm = true;
    },
    isObject(data) {
      return typeof data === "object" && data !== null;
    },
  },
};
</script>

<style>
.hvr-grow {
  display: inline-block;
  vertical-align: middle;
  transform: translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
  backface-visibility: hidden;
  -moz-osx-font-smoothing: grayscale;
  transition-duration: 0.3s;
  transition-property: transform;
}
</style>
